var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#BC172F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.729 30.9888L38 36.2586L36.2586 38L30.9888 32.729C29.028 34.3009 26.5892 35.1558 24.0761 35.1522C17.9621 35.1522 13 30.1901 13 24.0761C13 17.9621 17.9621 13 24.0761 13C30.1901 13 35.1522 17.9621 35.1522 24.0761C35.1558 26.5892 34.3009 29.028 32.729 30.9888ZM30.2603 30.0757C31.8221 28.4695 32.6944 26.3165 32.6909 24.0761C32.6909 19.3158 28.8351 15.4614 24.0761 15.4614C19.3158 15.4614 15.4614 19.3158 15.4614 24.0761C15.4614 28.8351 19.3158 32.6909 24.0761 32.6909C26.3165 32.6944 28.4695 31.8221 30.0757 30.2603L30.2603 30.0757Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.33c084586fa6a68410879fdfc497ee21.svg";
export { ForwardRef as ReactComponent };